<template>
	<div id="Main">
		<setpbox :type="type"></setpbox>
		<div v-if="type==2" class="type3">
			<div class="imgbox">
				<van-image class="img" width="100%" fit="contain" :src="require('../../assets/images/service/face.png')" />
				<van-button round type="info" class="submit" @click="submit(2)">开始人脸识别</van-button>
			</div>
		</div>
		<div v-if="type==3" class="type4">
			<div class="imgbox">
				<div class="title">
					<p class="p1">我的信息</p>
					<p class="p2">请检查上传信息是否正确</p>
				</div>
				<div class="inputbox">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/phone.png')" />手机号：</span>
					<van-field class="input" :value="phone" disabled />
				</div>
				<div class="inputbox bor0">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/faceid.png')" />身份证：</span>
				</div>
				<van-image class="img" width="100%" fit="contain" :src="idCardPositive" />
				<van-image class="img" width="100%" fit="contain" :src="idCardReverse" />
				<van-button round type="info" class="submit" @click="submit(3)" v-if="!over">申请</van-button>
			</div>
		</div>
	</div>
</template>
<script>
	import setpbox from '../../components/setpbox';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			setpbox
		},
		data() {
			return {
				type:2,/* 步骤数 */
				url:'',/* 人脸地址 */
				timedata:'',/* 验证时间 */
				phone: '',/* 手机号 */
				Positive: [],/* 正面图片 */
				verso: [],/* 国徽图片 */
				idCardPositive: '',/* 正面地址 */
				idCardReverse: '' ,/* 反面地址 */
				idCard: '', //身份证
				realName: '', //姓名
				faceKerneJson:'',
				over:false,/*表示最终审核提交 */
				openId:'',
				id:''
			}
		},
		methods: {
			submit(type) {
				if(type==2){/* 人脸识别结果获取 */
					window.location.href=this.url.Url/* 跳转第三方链接 */
				}else{/* 提交审核 */
					axiosPost.OpenAccount({/* 提交手机号和图片 */
						faceKerneTime:this.timedata,/* 时间 */
						faceKerneCode:0,/* 状态码 */
						faceKerneJson:this.faceKerneJson,/*, josn */
						phone:this.phone,
						openId:this.openId,/* 微信openId */
						validityTime:JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.OcrValidDate,/* 证件有效期 */
						idCard:  this.idCard,
						realName: this.realName,
					}).then((res) => {
						if (res.data.code == 200) {
							this.$toast({duration:4000,message:'申请成功！'});
							this.Journal();
							this.over=true
							this.$router.push({
								path: '/msghtml',
								query: {
									text:'开户申请成功！'
								}
							})
						} else {
							this.$toast({duration:4000,message:res.data.msg});
						}
					}).catch((res) => {
						window.console.log(res)
					})
				}
			},
			Journal(){/* 用户日志 */
				axiosPost.Journal({
					type:'开户',
					title:JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name+'提交了开户申请',
					details:JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name+'提交了开户申请',
					userId: this.phone,
					userName:JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name,
					logDate:this.timedata,/* 时间 */
				}).then((res) => {
					window.console.log(res)
				}).catch((res) => {
					window.console.log(res)
				})
			},
			geturl() {/* 获取人脸地址 */
				axiosPost.AuthResult({redirectUrl:'/identity?phone='+this.phone+'&openId='+this.openId+'&time='+this.time(),openId:this.openId}).then((res) => {
					window.console.log(res)
					if (res.data.code == 200) {
						this.url=JSON.parse(res.data.data)
						window.console.log(this.url)
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			judge(tpsat,token){
				axiosPost.getjudge({bizToken:token}).then((res) => {
					tpsat.clear()
					if (res.data.code == 200) {
						this.faceKerneJson=res.data.data
						if(JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.ErrCode==0){/* 成功 */
							this.idCardPositive='data:image/png;base64,'+JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).IdCardData.OcrBack
							this.idCardReverse='data:image/png;base64,'+JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).IdCardData.OcrFront
							this.idCard=JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.IdCard
							this.realName=JSON.parse(JSON.parse(this.faceKerneJson).DetectInfo).Text.Name
							this.$toast({duration:4000,message:'人脸验证成功！'});
							this.type=3;
						}else{/* 失败 */
							this.$toast({duration:4000,message:'人脸验证失败！请重新验证！'});
						}
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
				}).catch((res) => {
					tpsat.clear()
					window.console.log(res)
				})
			},
			time() {/* 验证时间开始计算 */
				let nowData = new Date()
				let month = nowData.getMonth() + 1;
				let strDate = nowData.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				let hour = nowData.getHours();//得到小时
				let minu = nowData.getMinutes();//得到分钟
				let sec = nowData.getSeconds();//得到秒
				let time = nowData.getFullYear()+ '-' + month + '-' + strDate + ' ' + hour + ':' +minu + ':' + sec
				return time;
			},
			gettoken(){/* 获取token */
				let tpsat=this.$toast.loading({
					message: '处理中',
					forbidClick: true,
					duration: 0
				});
				axiosPost.getBizTokenByOpenId({openId:this.openId}).then((res) => {
					if (res.data.code == 200) {
						this.judge(tpsat,res.data.data);
					} else {
						tpsat.clear()
						this.$toast({duration:4000,message:'获取结果失败，请重新认证！'});
					}
				}).catch((res) => {
					tpsat.clear()
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.phone = this.$route.query.phone
			this.openId=this.$route.query.openId
			if(this.$route.query.time){/* 有tocken第三方人脸后返回 */
				this.timedata=this.$route.query.time
				this.gettoken();
			}else{
				this.geturl();
			}
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;

		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin-bottom: 2rem;
		}
		.type3{
			.img{
				margin: 4rem 0;
			}
			.step {
				margin: 1rem 0;
				.box {
					font-size: 1.3rem;
					text-align: center;
			
					.icon {
						font-size: 1.9rem;
						margin-bottom: 0.2rem;
					}
				}
			}
		}
		.uploadbox {
			.Positive {
				width: 100%;
				font-size: 0;
				margin-bottom: 2rem;
			}

			.verso {
				width: 100%;
				font-size: 0;
				margin-bottom: 3rem;
			}
		}

		.imgbox {
			margin-top: 2rem;

			.title {
				margin-bottom: 1.5rem;

				.p1 {
					font-weight: bold;
					color: #161616;
					font-size: 1.8rem;
					line-height: 2.5rem;
				}

				.p2 {
					color: #999999;
					font-size: 1.4rem;
					line-height: 2rem;
				}
			}
		}

		.step {
			margin: 1rem 0;

			.box {
				font-size: 1.3rem;
				text-align: center;

				.icon {
					font-size: 1.9rem;
					margin-bottom: 0.2rem;
				}
			}
		}
		.bor0 {
			border-bottom: 0;
		}
		.inputbox {
			display: flex;
			margin-bottom: 0.8rem;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;
			padding: 1rem 0;
			line-height: 2.4rem;
		
			.input {
				padding: 0 1rem 0 0;
				flex: 1;
				line-height: 2.4rem;
				font-size: 1.6rem;
		
				input {
					color: #333333;
				}
			}
		
			.label {
				color: #fa6b6b;
				font-size: 1.6rem;
				margin-right: 0.6rem;
			}
		
			.icon {
				vertical-align: -0.2rem;
				margin-right: 0.6rem;
			}
		
		}
	}
</style>
